import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import ThemeProvider from './theme/ThemeProvider'
import AppErrorBoundary from './components/shared/AppErrorBoundary'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <AppErrorBoundary fullPage>
            <App />
          </AppErrorBoundary>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
)
